import { AlertsState } from '@/models/states/alerts-state.model';

export const state: AlertsState = {
  alerts: [],
};
